import { useEffect } from "react";

interface SchemaMarkupProps {
    data: Record<string, any>;
}

export function SchemaMarkup({ data }: SchemaMarkupProps) {
    useEffect(() => {
        // Generate a unique ID for the schema script to avoid duplicates
        const scriptId = `schema-org-${JSON.stringify(data).length}`;

        if (document.getElementById(scriptId)) return;

        const script = document.createElement("script");
        script.id = scriptId;
        script.type = "application/ld+json";
        script.text = JSON.stringify(data);
        document.head.appendChild(script);

        return () => {
            const existing = document.getElementById(scriptId);
            if (existing) {
                document.head.removeChild(existing);
            }
        };
    }, [data]);

    return null;
}
